import { useMemo } from "react";

import Grid from "@mui/material/Grid";
import DisplayPropertiesCard from "@covertree/ui/content/DisplayPropertiesCard";
import { formatAwsDateString } from "@covertree/utils";
import { LoadingOrValue } from "@covertree/ui";

import { PolicyDetailsContentProps } from "../../../types";

export function PrimaryInsured({ policy, loading }: PolicyDetailsContentProps) {
  const {
    policyholder: { firstName, middleName, lastName },
    insuredDateOfBirth,
  } = policy;

  const primaryInsuredName = useMemo(
    () => `${firstName} ${middleName ? middleName + " " : ""}${lastName}`,
    [firstName, middleName, lastName]
  );

  return (
    <Grid item xs={12}>
      <DisplayPropertiesCard
        properties={[
          {
            label: "Primary insured",
            value: (
              <LoadingOrValue
                loading={!policy && loading}
                value={primaryInsuredName}
                height={24}
                width={121}
              />
            ),
            showAsTypography: true,
            gridSize: 6,
          },
          {
            label: "Date of birth",
            value: (
              <LoadingOrValue
                loading={!policy && loading}
                value={formatAwsDateString(insuredDateOfBirth)}
                height={24}
                width={121}
              />
            ),
            showAsTypography: true,
            gridSize: 6,
          },
        ]}
      />
    </Grid>
  );
}
